var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduxPersist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#784BBC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,36.7c-0.1,0-0.2,0-0.2,0c-1.9-0.3-3.1-1.1-3.4-3.4c-0.4-2.7-1.8-5.1-3.9-7c-3-2.8-6.4-2.5-9.9-1.1 c-3.1,1.3-4.8,3.8-5.8,6.8c-2.4,6.6-1.6,13.1,1.7,19.2c0.2,0.5,0.6,0.5,1,0.5c1.6,0.1,3,1.2,3.3,2.6c0.4,1.6-0.3,3.2-1.7,4 c-1.3,0.7-2.9,0.6-4-0.4c-1.1-0.9-1.5-2.5-1-3.8c0.2-0.5,0.2-0.9-0.1-1.4c-2.2-3.8-3.5-7.9-3.6-12.2c-0.2-5.7,1.1-11.1,5.2-15.4 c4.4-4.5,10.7-5.4,15.6-2.2c3.6,2.4,5.5,6,6.5,10.2C77.5,34.5,77.7,35.6,77.7,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,43.7c1.2,2,0.8,3.4-0.9,4.9c-2,1.8-3.3,4.2-3.5,7c-0.4,5.5,3.4,9.7,9,10c5.4,0.3,9.9-1.8,14.1-5 c2.3-1.7,4.1-3.8,5.5-6.3c0.2-0.4,0.4-0.8,0-1.3c-0.9-1.3-0.9-2.9,0-4c0.9-1.2,2.3-1.7,3.7-1.4c1.5,0.4,2.5,1.6,2.7,3.1 c0.2,1.4-0.9,3.2-2.4,3.6c-0.6,0.2-0.9,0.5-1.2,1c-4,7.3-10.1,11.6-18.3,13c-3,0.5-5.9,0.3-8.7-0.8c-4.3-1.7-6.7-4.9-7.2-9.4 C39.4,51.9,42.4,47.3,47.2,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,66.8c0.9-0.7,1.7-1.3,2.4-2c0.4-0.4,0.8-0.2,1.2,0c2.6,1,5.2,1.4,7.9,0.8c5.6-1.2,8.7-6.8,6.7-12.2 c-1.9-5-5.7-8.2-10.4-10.4c-3.3-1.5-6.8-2.3-10.4-2.2c-0.5,0-0.8,0.2-1.1,0.6c-1.3,1.8-3.7,2.1-5.3,0.8c-1.6-1.3-1.7-3.7-0.2-5.2 c1.5-1.5,3.9-1.4,5.3,0.3c0.5,0.6,0.9,0.5,1.5,0.5c6.3,0,12,1.7,16.9,5.7c3.6,2.9,6.3,6.4,7.1,11c1,5.3-1.1,9.8-6,12.3 C78.7,69.6,73.6,69.1,68.3,66.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduxPersist);
export default __webpack_public_path__ + "static/media/Redux-Persist.3c8dee6cb1ecaae8541c003f3dbf9c65.svg";
export { ForwardRef as ReactComponent };